import React from 'react'

export default class Quote extends React.Component {
  constructor() {
    super();
    this.contentRef = React.createRef();

  }

  componentDidMount() {
  }

  render() {
    return (
      <div className="quote">
        <h4 className="foteller-name">{this.props.title}</h4>
        <q className="text-box" ref={this.contentRef}>
          {this.props.children}
        </q>
      </div>
    );
  }
}
